// extracted by mini-css-extract-plugin
export default {"inprogress":"Inprogress_inprogress__tFjUM","wrap":"Inprogress_wrap__Qxn+A","title":"Inprogress_title__4DxcR","desc":"Inprogress_desc__y7KoT","button":"Inprogress_button__Es3R7"};